import React, { useEffect, useState } from 'react';
import { Facebook, Instagram, Twitter, Youtube, Linkedin, MessageCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const SocialIcons = ({ className = "", iconSize = "w-5 h-5" }) => {
  const [socialLinks, setSocialLinks] = useState({
    facebook: "",
    instagram: "",
    twitter: "",
    youtube: "",
    linkedin: "",
    whatsapp: ""
  });

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await axios.get(`${BACKEND_URL}/api/social-links`);
        setSocialLinks(response.data);
      } catch (error) {
        console.error('Error fetching social links:', error);
      }
    };
    fetchSocialLinks();
  }, []);

  const socialIconsConfig = [
    { key: 'facebook', icon: Facebook, label: 'Facebook', color: 'hover:text-blue-600' },
    { key: 'instagram', icon: Instagram, label: 'Instagram', color: 'hover:text-pink-600' },
    { key: 'twitter', icon: Twitter, label: 'Twitter', color: 'hover:text-sky-500' },
    { key: 'youtube', icon: Youtube, label: 'YouTube', color: 'hover:text-red-600' },
    { key: 'linkedin', icon: Linkedin, label: 'LinkedIn', color: 'hover:text-blue-700' },
    { key: 'whatsapp', icon: MessageCircle, label: 'WhatsApp', color: 'hover:text-green-500' }
  ];

  const activeLinks = socialIconsConfig.filter(config => socialLinks[config.key]);

  if (activeLinks.length === 0) return null;

  return (
    <div className={`flex items-center space-x-4 ${className}`}>
      {activeLinks.map(({ key, icon: Icon, label, color }) => (
        <a
          key={key}
          href={socialLinks[key]}
          target="_blank"
          rel="noopener noreferrer"
          className={`text-gray-600 ${color} transition-colors duration-200`}
          aria-label={label}
          data-testid={`social-icon-${key}`}
        >
          <Icon className={iconSize} />
        </a>
      ))}
    </div>
  );
};

export default SocialIcons;
